import pick from 'lodash/pick';
import isArray from 'lodash/isArray';
import { logAccountActivity, logClientError } from 'src/common/actions/logging';
import isAuthFulfilledActionType from 'src/common/utils/auth/isAuthFulfilledActionType';

const LOG_ACTIVITY_MIDDLEWARE_ERROR = 'LOG_ACTIVITY_MIDDLEWARE_ERROR';

// [wells]: See the redux applyMiddleware source code to
// see how these middleware functions are created and called:
//
// https://github.com/reactjs/redux/blob/8637ab307aea30e4caf40b6e99559aba484e29be/src/applyMiddleware.js#L35
//
// The first argument passed to every middleware function is
// a middleware API that contains only two properties: 'getState' and 'dispatch'.
//
// The second argument 'next', points to the following function in the middleware chain.
// So as of 12/27/17, 'next' in logActivity is the 'createLogger' middleware (Development)
// or the 'routerMiddleware' (Production). If the middleware is the last in the chain, then
// 'next' is the original 'store.dispatch'. This final dispatch function will not be wrapped
// with any middleware (which means that it won't have support for thunks, for example).
//
// The final argument is the action that is currently being passed through the middleware chain.

const logActivity = (middlewareApi) => (next) => async (action) => {
  const { dispatch } = middlewareApi;
  const { type, meta } = action;
  const { actionToLog, labels } = pick(meta, ['actionToLog', 'labels']);
  try {
    if (!isAuthFulfilledActionType(type) || !actionToLog) {
      return next(action);
    }
    const logLabels = isArray(labels) ? labels : [];
    // [wells]: The middleware API's 'dispatch' must be called here directly in
    // order to trigger another state update when calling 'logAccountActivity'.
    // Once the log account activity call has resolved, the next function
    // in the middleware chain is called.
    await dispatch(logAccountActivity(actionToLog, logLabels));
    return next(action);
  } catch (ex) {
    dispatch(
      logClientError({
        message: `${LOG_ACTIVITY_MIDDLEWARE_ERROR}: ${ex && ex.message}`,
        context: { error: ex, type, meta },
      }),
    );
    return next(action);
  }
};

export default logActivity;
